<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <confirmation-modal v-if="isShown"></confirmation-modal>
    <first-time-login v-if="isFirstTimeLogin"></first-time-login>
    <router-view></router-view>
  </div>
</template>

<script>
import dwv from "dwv";
import ConfirmationModal from "./customReusableComponents/CustomConfirmationModal";
import FirstTimeLogin from "./customReusableComponents/FirstTimeLoginModal";

export default {
  components: {
    ConfirmationModal,
    FirstTimeLogin
  },
  computed: {
    isShown() {
      return this.$store.getters.showModal;
    },
    isFirstTimeLogin() {
      return this.$store.getters.showLoginModal;
    }
  },
  created() {
    this.$store.dispatch("autoLiginAttempt");
  },
  mounted() {
    // Global dwv init
    dwv.gui.getElement = dwv.gui.base.getElement;
    dwv.gui.displayProgress = function() {};
  }
};
</script>

<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>
